<template>
	<div class="c-register_segment">
		<Row>
			<Col span="20" offset="2" class="text-center">
				<p class="mt-10">
					If you are Segment user, click on the link below to activate
					the Akita destination.
				</p>
			</Col>
		</Row>
		<Row class="mt-3">
			<Col span="20" offset="2" class="text-center my-5">
				<segment-com-connect-button></segment-com-connect-button>
			</Col>
		</Row>
	</div>
</template>

<script>
export default {
	data() {
		return {
			title: "",
		};
	},
	components: {
		SegmentComConnectButton: function() {
			return import(
				"@/js/components/partials/segment-com-connect-button"
			);
		},
	},
	methods: {},
};
</script>
